import Dosa from "../images/dosa.jpg";
import Chola from "../images/chhola.jpg";
import Idli from "../images/idli.jpg";
import MasalaDosa from "../images/masala.jpg";
import Paneer from "../images/paneer.jpg";
import Gujrati from "../images/gujrati.jpeg";

export const MenuList = [
  {
    name: "Dosa",
    description:
      "Dosas originated in South India, but its precise geographical origins are unknown. Enjoy it!",
    image: Dosa,
    price: 80,
  },
  {
    name: "Chhole Bhatoore",
    description:
      "Chole bhature is a food dish popular in the Northern areas of the Indian subcontinent.Enjoy it!",
    image: Chola,
    price: 60,
  },
  {
    name: "Idli Sambhar",
    description:
      "Idli sambar is a super delicious hotel style tiffin sambar that is served with idli. Enjoy it!",
    image: Idli,
    price: 90,
  },
  {
    name: "Masala Dosa",
    description:
      "Masala Dosa is one that is crisp, aromatic, flavourful and has a potato masala or spiced seasoned potatoes stuffed in it. Enjoy it!",
    image: MasalaDosa,
    price: 100,
  },
  {
    name: "Paneer Butter Masala",
    description:
      "This creamy curry is made with onion, tomatoes, cashews, cream and butter (of course!). t has a mild sweet taste and pairs beautifully with garlic naan or jeera rice. Enjoy it!",
    image: Paneer,
    price: 240,
  },
  {
    name: "Gujrati Thali",
    description:
      "Gujarati Thali with undhiyu, dal, kadhi, lobia curry, sev tomato, dhokla, rice, roti and amrakhand. Enjoy it!",
    image: Gujrati,
    price: 311,
  },
];
